module.exports = __webpack_public_path__ + "static/media/commute-img-005.52b2f8e8.jpg";